let headers = document.querySelectorAll('#MainContent h2');
let tocListContainer = document.getElementById('toc');
let tocWrapper = document.getElementById('toc-wrapper');
let tocToggle = document.getElementById("toc-toggle")

if (headers.length) {
  tocWrapper.style.display = 'block';
}

headers.forEach(function (header) {
  header.id = header.textContent.replace(/\s/g, '-').toLowerCase();
  heading2 = header.textContent;
  let anchor = document.createElement('a');
  anchor.setAttribute('href', '#' + header.id);
  anchor.innerText = heading2;
  let item = document.createElement('li')
  item.className = "toc__item"
  item.append(anchor)
  tocListContainer.appendChild(item);
});

tocToggle.addEventListener("click", () => {
  if (tocWrapper.classList.contains("closed")) {
    tocWrapper.classList.remove("closed")
  } else {
    tocWrapper.classList.add("closed")
  }
})